export default __webpack_public_path__ + "static/media/mousepad.5b3d0051.jpg";